var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11583_845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.667 3H5.66699C4.56699 3 3.66699 3.9 3.66699 5V19C3.66699 20.1 4.56699 21 5.66699 21H19.667C20.767 21 21.667 20.1 21.667 19V5C21.667 3.9 20.767 3 19.667 3ZM19.667 19H5.66699V5H19.667V19Z",
    fill: "#84919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 12H7.66699V17H9.66699V12Z",
    fill: "#84919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.667 7H15.667V17H17.667V7Z",
    fill: "#84919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 14H11.667V17H13.667V14Z",
    fill: "#84919A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.667 10H11.667V12H13.667V10Z",
    fill: "#84919A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11583_845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.099bccec1f0a3d67a0e0380773a57876.svg";
export { ForwardRef as ReactComponent };